<template>
  <mdb-modal :show="isModalVisible" @close="closeModal" scrollable size="fluid" class="visualPrevieModal">
    <mdb-modal-header color="primary-color" textColor="white">
    </mdb-modal-header>
    <mdb-modal-body>
      <img :src="previewSrc" />
    </mdb-modal-body>
  </mdb-modal>
</template>

<script>
import { mdbModal, mdbModalHeader, mdbModalBody } from 'mdbvue'
import { appConfig } from '@/configs/config'

export default {
  components: {
    mdbModal,
    mdbModalHeader,
    mdbModalBody
  },
  created () {
    this.$parent.$on('showVisualPrevieModal', ({ reportId }) => {
      this.reportId = reportId
      this.showModal()
    })
  },
  data: () => ({
    isModalVisible: false,
    reportId: null
  }),
  computed: {
    previewSrc () {
      if (this.reportId) {
        const report = this.$store.getters['reports/REPORT']({ reportId: this.reportId })
        if (report.visual) {
          return appConfig.apiUrl + '/imagecache?query=' + report.visual
        }
      }
      return ''
    }
  },
  methods: {
    showModal () {
      this.isModalVisible = true
    },
    closeModal () {
      this.isModalVisible = false
    }
  }
}
</script>

<style lang="scss">
.visualPrevieModal {
  .modal-body {
    text-align: center;
  }
  img {
    margin: 0 auto;
  }
}
</style>
